export enum BookmarkType {
  Company = "company",
  Individual = "individual",
  Team = "team"
}
